import { Reference } from "@apollo/client";
import { ApolloCache } from "@apollo/client/cache";
import { Modifier } from "@apollo/client/cache/core/types/common";
import {
  matterTemplate,
  matterTemplate_matterTemplate,
} from "../__generated_types__/matterTemplate";
import { graphql } from "~/gql";

export const MATTER_TEMPLATE_QUERY = graphql(/* GraphQL */ `
  query matterTemplate($id: Float!) {
    matterTemplate(id: $id) {
      ...MatterTemplateParts
    }
  }
`);

export function updateFindMatterCache(
  cache: ApolloCache<any>,
  matterId: number,
  update: (matterTemplate: matterTemplate_matterTemplate) => Partial<matterTemplate_matterTemplate>
) {
  const { matterTemplate } =
    cache.readQuery<matterTemplate>({
      query: MATTER_TEMPLATE_QUERY,
      variables: { id: matterId },
    }) || {};
  if (matterTemplate) {
    cache.writeQuery({
      query: MATTER_TEMPLATE_QUERY,
      variables: { id: matterId },
      data: {
        matterTemplate: Object.assign({}, matterTemplate, update(matterTemplate)),
      },
    });
  }
}

export function modifyCachedMatter(
  cache: ApolloCache<any>,
  matterId: number,
  fieldModifiers: {
    phases: Modifier<Reference[]>;
  }
) {
  cache.modify({
    id: `Matter:${matterId}`,
    fields: fieldModifiers,
  });
}

export function modifyCachedPhase(
  cache: ApolloCache<any>,
  phaseId: number,
  fieldModifiers: {
    tasks: Modifier<Reference[]>;
  }
) {
  cache.modify({
    id: `Phase:${phaseId}`,
    fields: fieldModifiers,
  });
}
